import { useEffect } from 'react';

// Wallboard display care: keeps a panel that must stay on from sleeping or burning in.
const DRIFT_STEPS = [[0, 0], [3, 0], [3, 3], [0, 3], [-3, 3], [-3, 0], [-3, -3], [0, -3], [3, -3]];
const DRIFT_INTERVAL_MS = 60 * 1000;

export function useTvCare() {
  // Pixel drift: nudge the content a few pixels each minute so static edges never sit on the same pixels.
  useEffect(() => {
    let step = 0;
    const apply = () => {
      const [x, y] = DRIFT_STEPS[step % DRIFT_STEPS.length];
      document.documentElement.style.setProperty('--tv-drift-x', `${x}px`);
      document.documentElement.style.setProperty('--tv-drift-y', `${y}px`);
      step += 1;
    };
    apply();
    const timer = setInterval(apply, DRIFT_INTERVAL_MS);
    return () => {
      clearInterval(timer);
      document.documentElement.style.removeProperty('--tv-drift-x');
      document.documentElement.style.removeProperty('--tv-drift-y');
    };
  }, []);

  // Screen wake lock: ask the browser not to sleep the display; re-request after the tab becomes visible again.
  useEffect(() => {
    if (!('wakeLock' in navigator)) return undefined;
    let lock = null;
    let active = true;
    const request = async () => {
      try {
        lock = await navigator.wakeLock.request('screen');
      } catch {
        lock = null;
      }
    };
    const onVisible = () => { if (active && document.visibilityState === 'visible') request(); };
    request();
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      active = false;
      document.removeEventListener('visibilitychange', onVisible);
      lock?.release().catch(() => {});
    };
  }, []);
}
